
import { IAggregation } from "./IAggregation";


export class Aggregation implements IAggregation
{
    dataSourceId: number = 0;
    creationDate: Date = new Date();
    average: number = 0;
    count: number = 0;
    maximum: number = 0;
    minimum: number = 0;
    median: number = 0;
    standardDeviation: number = 0;
    sum: number = 0;
    signalQuality: number = 0;
}
